import * as React from 'react';
import { observer } from 'mobx-react';
import mStyle from './LayoutTitle.module.scss';
import { JoinClassName } from '../../../utils/string';
import { FlexLayoutProps, Global } from '../../../constants';
import { FlexLayout } from '../../layout';
import { t } from '../../../stores/TranslateStore';

interface LayoutTitleProps extends FlexLayoutProps {
  /**
   * children 을 현재 언어로 번역할지 여부. 기본값 true.
   *
   * t.T 는 children 이 문자열일 때만 번역하고 JSX·숫자 등은 그대로 통과시키므로,
   * children 이 순수 텍스트가 아니면 이 값과 무관하게 안전하다. 하지만 children 이
   * 레코드 데이터가 담긴 문자열(고객명, 코드, 날짜 등)이면 translate={false} 로
   * 꺼야 한다 — 켜두면 그 값이 외부 모델로 나가고 전 테넌트 공유 사전에 영구
   * 저장된다.
   */
  translate?: boolean;
}

// observer: 번역이 배치로 도착하면 t.dict 가 바뀌므로 다시 그려야 한다.
export const LayoutTitle: React.FC<LayoutTitleProps> = observer(({
  className,
  style,
  children,
  weight,
  size,
  align,
  justify,
  highlight,
  translate = true,
}) => (
  <FlexLayout
    className={JoinClassName.make([
      mStyle.container,
      highlight ? mStyle.highlight : false,
      className,
    ])}
    weight={weight}
    size={size || Global.LAYOUT_TITLE_HEIGHT_1}
    align={align || 'center'}
    justify={justify || 'center'}
    style={{
      padding: '4px 8px',
      ...style,
    }}
  >
    <span>{translate ? t.T(children) : children}</span>
  </FlexLayout>
));
